import React from 'react';

const ShopRevenueCenterTitle = ({ record }) => {
	return <span>ShopRevenueCenter {record ? `"${record.name}"` : ''}</span>;
};

export default ShopRevenueCenterTitle;
